//React
import React from 'react';

// MUI
import { Grid, Button } from '@mui/material';

// Libs
import i18n from '../i18n';

// Configurations
import DeviceBreakPoints from '../configurations/deviceBreakpoints';

// Interfaces

//utils
import { isEmpty } from '../utils/util';
function NavigationButtons(props) {
  var _props$dynamicForm7;
  var _DeviceBreakPoints = DeviceBreakPoints(),
    isSmallDevice = _DeviceBreakPoints.isSmallDevice;
  var handleBack = function handleBack() {
    if ((props === null || props === void 0 ? void 0 : props.activeTab) !== 1) props === null || props === void 0 || props.handleActiveTab((props === null || props === void 0 ? void 0 : props.activeTab) - 1);
  };
  var buttonDynamicFormPreviousButton = function buttonDynamicFormPreviousButton() {
    var _props$dynamicForm, _props$dynamicForm2;
    return props !== null && props !== void 0 && (_props$dynamicForm = props.dynamicForm) !== null && _props$dynamicForm !== void 0 && _props$dynamicForm.previousButtonTitle ? props === null || props === void 0 || (_props$dynamicForm2 = props.dynamicForm) === null || _props$dynamicForm2 === void 0 ? void 0 : _props$dynamicForm2.previousButtonTitle : i18n.t('REGISTRATION.BACK');
  };
  var buttonDynamicFormSubmitButton = function buttonDynamicFormSubmitButton() {
    var _props$dynamicForm3, _props$dynamicForm4;
    return props !== null && props !== void 0 && (_props$dynamicForm3 = props.dynamicForm) !== null && _props$dynamicForm3 !== void 0 && _props$dynamicForm3.submitButtonTitle ? props === null || props === void 0 || (_props$dynamicForm4 = props.dynamicForm) === null || _props$dynamicForm4 === void 0 ? void 0 : _props$dynamicForm4.submitButtonTitle : i18n.t('REGISTRATION.SUBMIT');
  };
  var buttonDynamicFormNextButton = function buttonDynamicFormNextButton() {
    var _props$dynamicForm5, _props$dynamicForm6;
    return props !== null && props !== void 0 && (_props$dynamicForm5 = props.dynamicForm) !== null && _props$dynamicForm5 !== void 0 && _props$dynamicForm5.nextButtonTitle ? props === null || props === void 0 || (_props$dynamicForm6 = props.dynamicForm) === null || _props$dynamicForm6 === void 0 ? void 0 : _props$dynamicForm6.nextButtonTitle : i18n.t('REGISTRATION.PROCEED');
  };
  var buttonWidth = function buttonWidth() {
    if (isSmallDevice) return 'auto';else return '140px';
  };
  var buttonHeight = function buttonHeight() {
    if (isSmallDevice) return '35px';else return '45px';
  };
  var buttonPadding = function buttonPadding() {
    if (isSmallDevice) return '9px';else return '16px';
  };
  var buttonLeftMargin = function buttonLeftMargin() {
    if (isSmallDevice) return '5px !important';else return '18px !important';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: 'space-between',
    sx: {
      marginTop: '16px',
      padding: '0 16px'
    }
  }, (props === null || props === void 0 ? void 0 : props.activeTab) !== 1 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    sx: {
      width: buttonWidth(),
      height: buttonHeight(),
      paddingLeft: buttonPadding(),
      paddingRight: buttonPadding()
    },
    onClick: function onClick() {
      return handleBack();
    }
  }, isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm) ? i18n.t('REGISTRATION.BACK') : buttonDynamicFormPreviousButton())), isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: (props === null || props === void 0 ? void 0 : props.activeTab) === 1 ? 12 : 11,
    sx: {
      display: 'flex',
      justifyContent: 'end'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    sx: {
      width: buttonWidth(),
      height: buttonHeight(),
      paddingLeft: buttonPadding(),
      paddingRight: buttonPadding()
    },
    onClick: (props === null || props === void 0 ? void 0 : props.activeTab) !== 3 ? function (event) {
      return props === null || props === void 0 ? void 0 : props.onButtonClick(event);
    } : function () {
      props === null || props === void 0 || props.cancelHandler();
      props === null || props === void 0 || props.setOpenRegisterModal(false);
    }
  }, i18n.t('REGISTRATION.SAVE')), (props === null || props === void 0 ? void 0 : props.activeTab) !== 3 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    "data-testid": "company-next",
    sx: {
      width: buttonWidth(),
      height: buttonHeight(),
      paddingLeft: buttonPadding(),
      paddingRight: buttonPadding(),
      marginLeft: buttonLeftMargin()
    },
    onClick: function onClick(event) {
      return props === null || props === void 0 ? void 0 : props.onButtonClick(event);
    }
  }, i18n.t('REGISTRATION.NEXT')) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    sx: {
      width: buttonWidth(),
      height: buttonHeight(),
      paddingLeft: buttonPadding(),
      paddingRight: buttonPadding(),
      marginLeft: buttonLeftMargin()
    },
    onClick: function onClick() {
      props === null || props === void 0 || props.setOpenConfirmModal(true);
    },
    disabled: props === null || props === void 0 ? void 0 : props.isSubmitDisabled
  }, i18n.t('REGISTRATION.SUBMIT'))), !isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: (props === null || props === void 0 ? void 0 : props.activeTab) === 1 ? 12 : 11,
    sx: {
      display: 'flex',
      justifyContent: 'end'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    sx: {
      width: buttonWidth(),
      height: buttonHeight(),
      paddingLeft: buttonPadding(),
      paddingRight: buttonPadding(),
      marginLeft: buttonLeftMargin()
    },
    onClick: function onClick(event) {
      return props === null || props === void 0 ? void 0 : props.onButtonClick(event);
    },
    disabled: props === null || props === void 0 ? void 0 : props.isSubmitDisabled
  }, (props === null || props === void 0 || (_props$dynamicForm7 = props.dynamicForm) === null || _props$dynamicForm7 === void 0 || (_props$dynamicForm7 = _props$dynamicForm7.steps) === null || _props$dynamicForm7 === void 0 ? void 0 : _props$dynamicForm7.length) === (props === null || props === void 0 ? void 0 : props.activeTab) ? buttonDynamicFormSubmitButton() : buttonDynamicFormNextButton()))));
}
;
export default NavigationButtons;